import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { advertisement, ServiceService } from '../../service.service';

@Component({
  selector: 'app-tablas',
  templateUrl: './tablas.component.html',
  styleUrls: ['./tablas.component.scss'],
})
export class TablasComponent implements OnInit {

  menuArray:Array<any> = new Array();
  showTables:boolean = false;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(    
      private firebaseAnalytics: FirebaseAnalytics,
      public services: ServiceService,
      public router: Router
    ) {

      this.firebaseAnalytics.logEvent;
      this.firebaseAnalytics.setCurrentScreen("Tablas");
      this.setUpMenu();
   }


  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  public setUpMenu(){
    this.menuArray.push({
      ruta: '/EqvAcabSuperficialesRa',
      desc: 'Equivalencias para acabados superficiales RA',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/TolerIsoDE',
      desc: 'Tolerancia ISO para diámetro nominal exterior',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/TolerIsoDI',
      desc: 'Tolerancia ISO para diámetro nominal interior',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/RoscAmerEstdTolerP',
      desc: 'Roscas americanas estandarizadas, tolerancias y paso',
      icon: './assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/TamBrocasFraccMetricoNumAlfa',
      desc: 'Tamaño de brocas fraccionales, métrico, númerico y alfabético',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/BrocasRecomendadasMachuel',
      desc: 'Brocas recomendadas para machuelear roscas milimétricas',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/BrocasRecmenMachuelearRoscPulg',
      desc: 'Brocas recomendadas para machuelear roscas pulgadas',
      icon: '../assets/images/calculadora/rpm.png'
    });
  }

  home() {
    return this.router.navigate(['/calculadora']);
  }

}
